<template>
  <div class="grid grid-cols-3 gap-6 text-sm">
    <dl>
      <dt>ID da conta</dt>
      <dd>#{{ data.account_id }}</dd>
    </dl>
    <dl>
      <dt>ID da autorização</dt>
      <dd>#{{ data.aut_id }}</dd>
    </dl>
    <dl>
      <dt>Status</dt>
      <dd>
        {{ data.aut_status }}
      </dd>
    </dl>
    <dl>
      <dt>Volume total</dt>
      <dd>
        {{ data.global_fin_volume | currency }}
      </dd>
    </dl>
    <dl>
      <dt>Limite por operação</dt>
      <dd>
        {{ data.trade_fin_volume | currency }}
      </dd>
    </dl>
    <dl>
      <dt>Limite de operações simultâneas</dt>
      <dd>
        {{ data.max_positions }}
      </dd>
    </dl>
    <dl>
      <dt>Validade das autorizações</dt>
      <dd>
        {{ data.aut_num_days }}
      </dd>
    </dl>
    <dl>
      <dt>Parceiro</dt>
      <dd>
        {{ data.partner_name }}
      </dd>
    </dl>
    <dl>
      <dt>Horário de criação</dt>
      <dd>
        {{ date(data.aut_create_date) }}
      </dd>
    </dl>
    <dl>
      <dt>Horário limite</dt>
      <dd>
        {{ date(data.aut_limit_date) }}
      </dd>
    </dl>
    <dl v-if="data.aut_disable_date">
      <dt>Horário de desativação</dt>
      <dd>
        {{ date(data.aut_disable_date) }}
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    authId: {
      type: Number,
    },
  },

  data() {
    return {
      data: {},
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
  },

  methods: {
    date(date) {
      return this.moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    getData() {
      return this.$api
        .get(this.$endpoint.GET_AUTH_INFO, {
          params: {
            account_id: this.getSelectedAccount.account_id,
            aut_id: this.authId,
          },
        })
        .then((res) => {
          // console.log(res);
          this.data = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },

  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
dt {
  @apply text-gray-500 dark:text-gray-400;
}
</style>
